import React from "react";
import TextBox from "carbon-react/lib/__experimental__/components/textbox";
import SearchButton from "../common/SearchButton";
import { Row, Column } from "carbon-react/lib/components/row";
import {
  Select,
  Option,
} from "carbon-react/lib/__experimental__/components/select";
import {
  agentFieldNames,
  getAllAgentRoles,
  agentStatuses,
  psuedoAgentStatusInvitePending,
} from "../../constants/model";

import "./AgentFilter.css";

const searchByAll = "all";

const filterByOptionMetadata = [
  {
    id: "manage-agents-filter-search-by-show-all",
    text: "Show All",
    value: searchByAll,
    key: searchByAll,
  },
  {
    id: "manage-agents-filter-search-by-email",
    text: "Email",
    value: agentFieldNames.email,
    key: agentFieldNames.email,
  },
  {
    id: "manage-agents-filter-search-by-role",
    text: "Role",
    value: agentFieldNames.role,
    key: agentFieldNames.role,
  },
  {
    id: "manage-agents-filter-search-by-status",
    text: "Status",
    value: agentFieldNames.status,
    key: agentFieldNames.status,
  },
];

const agentRoles = getAllAgentRoles();

const agentStatusOptionMetadata = [
  agentStatuses.active,
  agentStatuses.deactivated,
  psuedoAgentStatusInvitePending,
];

const AgentFilter = ({
  searchBy,
  onSearchByChanged,
  searchValue,
  onSearchValueChanged,
  onSearch,
}) => {
  const onEmailSearchTermChanged = (searchTerm) => {
    searchTerm = searchTerm.trim();
    onSearchValueChanged(searchTerm);
  };

  const onSearchTermKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      performSearch();
    }
  };

  const _onSearchByChanged = (newSearchBy) => {
    onSearchByChanged(newSearchBy);

    switch (newSearchBy) {
      case searchByAll:
        onSearchValueChanged("");
        forceSearchBypassingState(searchByAll, null);
        return;
      case agentFieldNames.role:
        const defaultRole = agentRoles[0];
        onSearchValueChanged(defaultRole.value);
        forceSearchBypassingState(newSearchBy, defaultRole.value);
        return;
      case agentFieldNames.status:
        const defaultStatus = agentStatusOptionMetadata[0];
        onSearchValueChanged(defaultStatus.value);
        forceSearchBypassingState(newSearchBy, defaultStatus.value);
        return;
      default:
        onSearchValueChanged("");
    }
  };

  const onRoleSearchValueChanged = (role) => {
    onSearchValueChanged(role);
    forceSearchBypassingState(searchBy, role);
  };

  const onStatusSearchValueChanged = (status) => {
    onSearchValueChanged(status);
    forceSearchBypassingState(searchBy, status);
  };

  const forceSearchBypassingState = (forceSearchBy, forceSearchValue) => {
    //  Necessary to ensure search performed with latest state - React state sync issue
    onSearch(forceSearchBy, forceSearchValue);
  };

  const performSearch = () => {
    onSearch();
  };

  const searchValueInputControl = (
    <>
      {searchBy && searchBy === agentFieldNames.role ? (
        <Select
          id="manage-agents-filter-search-role"
          preventFocusAutoOpen={true}
          filterable={false}
          placeholder={"Select role..."}
          value={searchValue}
          onChange={(e) => {
            onRoleSearchValueChanged(e.target.value[0].optionValue);
          }}
        >
          {agentRoles.map((agentRole) => {
            return (
              <Option
                id={`manage-agents-filter-search-role-${agentRole.value}`}
                key={agentRole.value}
                text={agentRole.displayValue}
                value={agentRole.value}
              />
            );
          })}
        </Select>
      ) : searchBy && searchBy === agentFieldNames.status ? (
        <Select
          id="manage-agents-filter-search-status"
          preventFocusAutoOpen={true}
          filterable={false}
          placeholder={"Select status..."}
          value={searchValue}
          onChange={(e) => {
            onStatusSearchValueChanged(e.target.value[0].optionValue);
          }}
        >
          {agentStatusOptionMetadata.map((agentStatus) => {
            return (
              <Option
                id={`manage-agents-filter-search-status-${agentStatus.value}`}
                key={agentStatus.value}
                text={agentStatus.displayValue}
                value={agentStatus.value}
              />
            );
          })}
        </Select>
      ) : searchBy && searchBy === searchByAll ? (
        <TextBox
          id="manage-agents-filter-search-all"
          disabled
          value={searchValue}
        />
      ) : (
        <TextBox
          id="manage-agents-filter-search-email"
          placeholder={`Enter search term (or leave blank to show All)...`}
          value={searchValue}
          onChange={(e) => onEmailSearchTermChanged(e.target.value)}
          onKeyDown={onSearchTermKeyDown}
        />
      )}
    </>
  );

  return (
    <form
      className="agent-filters"
      onSubmit={(e) => {
        e.preventDefault();
        performSearch();
      }}
    >
      <Row className="manage-agents-filter-row" columns="9" gutter="medium">
        <Column
          className="audit-log-filter-column"
          columnAlign="left"
          columnSpan="2"
        >
          <Select
            id="manage-agents-filter-search-by"
            autoFocus
            preventFocusAutoOpen={true}
            filterable={false}
            placeholder={"Search by..."}
            value={searchBy}
            onChange={(e) => {
              _onSearchByChanged(e.target.value[0].optionValue);
            }}
          >
            {filterByOptionMetadata.map((filterOption) => {
              return (
                <Option
                  id={`manage-agents-filter-search-by-${filterOption.value}`}
                  key={filterOption.key}
                  text={filterOption.text}
                  value={filterOption.value}
                />
              );
            })}
          </Select>
        </Column>
        <Column
          className="manage-agents-filter-column"
          columnAlign="left"
          columnSpan="3"
        >
          {searchValueInputControl}
        </Column>
        <Column
          className="manage-agents-filter-column"
          columnAlign="left"
          columnSpan="2"
        >
          <SearchButton id="manage-agents-filter-search-btn" type="submit" />
        </Column>
      </Row>
    </form>
  );
};

export default AgentFilter;
export { searchByAll };
